import React from "react";
import axios from "axios";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Label,
  Input,
  Col,
} from "reactstrap";
import { WAVE_USERS_URL } from "../actions/types";
import ErrorAlert from "../components/Modals/ErrorAlert";
import SuccessAlert from "../components/Modals/SuccessAlert";
import { Spinner } from "reactstrap";

export default function ForgottenPasswordModal({
  forgottenPassowrdOpen,
  toggleForgottenPassowrd,
}) {
  const [form, setForm] = React.useState({
    username: "",
    email: "",
  });
  const [loading, setLoading] = React.useState(false);

  const submitForm = (e) => {
    e.preventDefault();
    if (loading === false) {
      setLoading(true);
      axios
        .post(WAVE_USERS_URL + "request_reset_password/", form)
        .then((res) => {
          toggleForgottenPassowrd();
          setForm({
            username: "",
            email: "",
          });
          SuccessAlert(
            "We have sent you an email with the steps to reset your password."
          );
          setLoading(false);
        })
        .catch((error) => {
          ErrorAlert(error.response.data.detail);
          setLoading(false);
        });
    }
  };

  return (
    <Modal
      isOpen={forgottenPassowrdOpen}
      toggle={toggleForgottenPassowrd}
      centered={true}
      size="lg"
      className="modalLogin"
    >
      <ModalHeader toggle={toggleForgottenPassowrd}>Form</ModalHeader>
      <ModalBody>
        <Form id="registration-form" onSubmit={submitForm}>
          <FormGroup row>
            <Label for="form-username" sm={4}>
              Username
            </Label>
            <Col sm={8}>
              <Input
                value={form.username}
                onChange={(e) =>
                  setForm({ ...form, [e.target.name]: e.target.value })
                }
                type="text"
                name="username"
                id="form-username"
                placeholder=""
                required
              />
            </Col>
          </FormGroup>
          <br />
          <FormGroup row>
            <Label for="form-email" sm={4}>
              Email
            </Label>
            <Col sm={8}>
              <Input
                value={form.email}
                onChange={(e) =>
                  setForm({ ...form, [e.target.name]: e.target.value })
                }
                type="email"
                name="email"
                id="form-email"
                placeholder=""
                required
              />
            </Col>
          </FormGroup>
        </Form>
      </ModalBody>
      <ModalFooter>
        {loading === true ? (
          <Button
            color="primary"
            form="registration-form"
            style={{ minWidth: 130 }}
          >
            <Spinner size="sm"> </Spinner>
          </Button>
        ) : (
          <Button
            color="primary"
            type="submit"
            form="registration-form"
            style={{ minWidth: 130 }}
          >
            Reset password
          </Button>
        )}
      </ModalFooter>
    </Modal>
  );
}
